import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";


function WorkCenterPage() {
  const [data, setData] = useState({
    name: "",
    capacity_per_day: ""
  });
  const [rows, setRows] = useState([]);
  const [wcs, setWCs] = useState([]);
  const inputHandler = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };
  useEffect(() => {
    fetchWCs();
  }, []);

  // Fetch BOM list
  const fetchWCs = () => {
    axios.get(baseUrl + "workcenters/")
      .then(res => setRows(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch BOMs", "error"));
  };

  const formSubmit = () => {
    if (!data.name || data.capacity_per_day === "") {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("name", data.name);
    _formData.append("capacity_per_day", data.capacity_per_day);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "workcenters/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          Swal.fire({
            title: "Work Center Created",
            icon: "success",
            timer: 2000,
            showConfirmButton: false
          });
        setTimeout(() => {
          window.location.href = ('/work-centers/');
        }, 2000);
          // Reset form
          setData({
            name: "",
            capacity_per_day: ""
          });
        }
      })
      .catch(() => {
        Swal.fire("Error", "Something went wrong", "error");
      });
  };

// Delete BOMItem
  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Are you sure you want to delete this?",
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "workcenters/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "BOM Item deleted", "success");
            fetchWCs();
          });
      }
    });
  };

const columns = [
    { field: "id", headerName: "ID", width: 80 },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      renderCell: (params) => params.row?.name || "Unknown"
    },
    { field: "capacity_per_day", headerName: "Capital/Day", flex: 1 },
    {
      field: "edit",
      headerName: "Edit",
      renderCell: (params) => (
        <Link
          to={`/work-centers/edit/${params.row.id}/`}
          target="_blank"
          className="btn btn-warning btn-sm"
        >
          Edit
        </Link>
      ),
      width: 120
    },
    {
      field: "delete",
      headerName: "Delete",
      renderCell: (params) => (
        <button
          onClick={() => handleDelete(params.row.id)}
          className="btn btn-danger btn-sm"
        >
          Delete
        </button>
      ),
      width: 120
    }
  ];

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Add Work Center</h4>

        <input
          type="text"
          className="form-control mt-3"
          placeholder="Work Center Name"
          name="name"
          value={data.name}
          onChange={inputHandler}
        />

        <input
          type="number"
          className="form-control mt-3"
          placeholder="Capacity per Day"
          name="capacity_per_day"
          value={data.capacity_per_day}
          onChange={inputHandler}
        />

        <button
          className="btn btn-success mt-3"
          onClick={formSubmit}
        >
          Submit
        </button>
      </div>
      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": { color: "primary.main" }
          }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default WorkCenterPage;
